import { BlockchainType } from '@shared/types/services/enums';
import { ethers } from 'ethers';
import validateSolAddress from './validateSolAddress';
import { validateFESuiAddress } from './validateFESuiAddress';
export const detectAddressType = recipient => {
  if (ethers.utils.isAddress(recipient)) {
    return BlockchainType.EVM;
  }
  if (validateSolAddress(recipient)) {
    return BlockchainType.SVM;
  }
  if (validateFESuiAddress(recipient)) {
    return BlockchainType.MOVE;
  }
  return undefined;
};